/* istanbul ignore file */
"use client";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function NotFound() {
  const router = useRouter();
  useEffect(() => {
    router.replace("/404");
  }, [router]);
}
